export const getList = state => state.list;
export const getListForUser = state => state.listForUser;
export const getApplication = state => state.application;
export const getTags = state => state.tags;
